var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("\n    "+_vm._s(_vm.$t('you are low on credits'))+"\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.$tc(
        'you have only 1 credit left | you have only {count} credits left to spend',
        _vm.totalCredits
      ))+".\n    "),_c('a',{attrs:{"href":_vm.creditRenewalPageUrl},on:{"click":_vm.handleBuyMoreButtonClick}},[_vm._v("\n      "+_vm._s(_vm.$t('buy more credits').toLocaleLowerCase())+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }